import React from 'react'
import OobeLayout from '../src/components/OobeLayout'
import packageInfo from '../package.json'
import styled from 'styled-components'
import ShellRootProvider from '../src/contexts/ShellRoot/ShellRootProvider'

export const Section = styled.section`
  height: 100%;
`

export default function Root(sidebarProps) {
  const { v1, v2 } = window.Shell
  const { store, localization } = v1

  return (
    <Section id={packageInfo.name}>
      <ShellRootProvider interfaces={{ v1, v2 }}>
        <OobeLayout
          store={store}
          localization={localization}
          sidebarProps={sidebarProps}
        />
      </ShellRootProvider>
    </Section>
  )
}
